import { testimonials } from "@/mocks/comics";

const principles = [
  { icon: "ri-heart-line", title: "零门槛优先", desc: "不设付费墙，先把海量内容免费开放给每一个人。" },
  { icon: "ri-edit-line", title: "内容真实多元", desc: "覆盖十大分类，题材丰富，尊重每一部作品的创作表达。" },
  { icon: "ri-shield-check-line", title: "阅读体验至上", desc: "清爽无打扰的阅读界面，把注意力还给剧情本身。" },
];

export default function About() {
  return (
    <section className="mx-auto max-w-page px-4 py-14 md:px-6 md:py-20">
      <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="flex flex-col justify-center">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-xs font-bold text-primary-700 md:text-sm">
            品牌介绍与口碑
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl">让看漫画这件事，变得简单又免费</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            虫虫漫画是一个专注于为所有读者提供免费漫画阅读的平台。我们相信，
            好的故事不应该被付费的门槛挡住。因此我们把核心的阅读体验完整地留给免费用户，
            用每日奖励和零门槛入口，让每个人都能毫无负担地追到自己喜欢的作品。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            无论你是刚入坑的新人，还是阅漫无数的大神，都能在这里找到属于自己的那一页。
            我们始终坚持内容真实、体验清爽、平台开放，和千万读者一起，把追更变成一件快乐的小事。
          </p>

          <div className="mt-7 space-y-4">
            {principles.map((p) => (
              <div key={p.title} className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold md:text-base">{p.title}</h3>
                  <p className="mt-0.5 text-xs text-foreground-700 md:text-sm">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <i className="text-2xl text-primary-300 ri-double-quotes-l"></i>
              <blockquote className="mt-2 text-sm leading-relaxed text-foreground-800 md:text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                  {t.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-bold">{t.name}</p>
                  <p className="text-xs text-foreground-600">{t.role}</p>
                </div>
                <span className="ml-auto flex gap-0.5 text-primary-500">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="text-xs ri-star-fill"></i>
                  ))}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}